import { Container } from "@opensea/ui-kit"
import type { PropsWithChildren } from "react"

export function PageFooterContainer({ children }: PropsWithChildren) {
  return (
    <div className="hidden h-page-footer lg:block">
      <footer className="fixed right-scroll-bar-size bottom-0 left-side-nav z-[calc(var(--z-sidebar)-1)] h-page-footer border-border-1 border-t bg-bg-app lg:right-[calc(theme(spacing.scroll-bar-size))]">
        <Container className="flex h-full items-center">{children}</Container>
      </footer>
    </div>
  )
}
